import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStudentMedicalBenefitsTugo, makeSelectStudentMedicalBenefitsTugoErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import PageSectionHeader from '../components/PageSectionHeader';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormFields,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required } from '../../../utils/validation/validator';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectFormHasChanges } from '../../App/selectors';
import { setFormHasChanges } from '../../App/actions';
import FlexBox from '../../../components/FlexBox';
import FNOLTooltip from '../../../components/FNOLTooltip';
import { stepStudentMedicalBenefitsTugoLookup } from '../dataMapper/claimCodeMapper';
import WizardNavigationButtons from '../components/WizardNavigationButtons';
import DatePicker from '../components/DatePicker/index';

export class StudentMedicalBenefitsTugo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };

    this.radioFormResets = {
      ambulanceGroundService: {
        true: ['infoGroundAmbulanceItems'],
        false: ['infoGroundAmbulanceItems', 'ambulanceAirService', 'infoAirAmbulanceItems'],
      },
      ambulanceAirService: {
        true: ['infoAirAmbulanceItems'],
        false: ['infoAirAmbulanceItems'],
      },
      // Doctor Visit fields
      doctorVisitTelemedicine: {
        true: [],
        false: ['infoTelemedicineItems'],
      },
      doctorVisitAnnualPhysicalExam: {
        true: ['infoAnnualPhysicalExamItems', 'doctorVisitFirstVisit', 'infoOutpatientPhysicianFeesItems', 'doctorVisitFollowUp', 'infoFollowUpVisitItems', 'doctorVisitFollowUpFracture', 'infoFollowUpFractureItems'],
        false: ['infoAnnualPhysicalExamItems'],
      },
      doctorVisitFirstVisit: {
        true: ['infoOutpatientPhysicianFeesItems', 'infoAnnualPhysicalExamItems'],
        false: ['infoOutpatientPhysicianFeesItems'],
      },
      doctorVisitFollowUp: {
        true: ['infoFollowUpVisitItems'],
        false: ['infoFollowUpVisitItems', 'doctorVisitFollowUpFracture', 'infoFollowUpFractureItems'],
      },
      doctorVisitFollowUpFracture: {
        true: ['infoFollowUpFractureItems'],
        false: ['infoFollowUpFractureItems'],
      },
      doctorVisitSTIVaccinationsTBEyeExam: {
        true: [],
        false: ['doctorVisitSTITesting', 'doctorVisitVaccinationsTBTesting', 'doctorVisitEyeExamination', 'infoSTITestingItems', 'infoVaccinationsTBTestingItems', 'infoEyeExaminationItems'],
      },
    };


    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      this.props.setFormHasChanges(true);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(6);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  handleExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);

    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      // Reset form fields when unchecking new medical expense types
      if (name === "Doctor's Visit") {
        this.props.onResetFormCustom([
          'doctorVisitTelemedicine',
          'infoTelemedicineItems',
          'doctorVisitAnnualPhysicalExam',
          'doctorVisitFirstVisit',
          'doctorVisitFollowUp',
          'doctorVisitFollowUpFracture',
          'doctorVisitSTIVaccinationsTBEyeExam',
          'doctorVisitSTITesting',
          'doctorVisitVaccinationsTBTesting',
          'doctorVisitEyeExamination',
          'infoAnnualPhysicalExamItems',
          'infoOutpatientPhysicianFeesItems',
          'infoFollowUpVisitItems',
          'infoFollowUpFractureItems',
          'infoSTITestingItems',
          'infoVaccinationsTBTestingItems',
          'infoEyeExaminationItems',
        ]);
      }
      if (name === 'Diagnostic Tests') {
        this.props.onResetFormCustom(['infoDiagnosticTestsItems']);
      }
      if (name === 'Prescription Drugs') {
        this.props.onResetFormCustom(['infoPrescriptionDrugsItems']);
      }
      if (name === 'Ambulance Services') {
        this.props.onResetFormCustom([
          'ambulanceGroundService',
          'ambulanceAirService',
          'infoGroundAmbulanceItems',
          'infoAirAmbulanceItems',
        ]);
      }
      if (name === 'Hospitalization') {
        this.props.onResetFormCustom([
          'hospitalizationHospitalInvoice',
          'hospitalizationPhysicianInvoice',
          'hospitalizationLabDiagnostic',
          'hospitalizationOtherRelated',
          'hospitalizationMentalHealthPsychiatric',
          'hospitalizationEmergencyAirTransportation',
          'hospitalizationAirfareReturnHome',
          'hospitalizationFamilyTransportation',
          'hospitalizationMedicalAttendant',
          'infoHospitalFeesItems',
          'infoInpatientPhysicianFeesItems',
          'infoXrayLabsDiagnosticsItems',
          'infoOtherHospitalizationItems',
          'infoMentalHealthPsychiatricItems',
          'infoEmergencyAirTransportationItems',
          'infoAirfareReturnHomeItems',
          'infoFamilyTransportationItems',
          'infoMedicalAttendantItems',
        ]);
      }
      if (name === 'Essential Medical Appliances') {
        this.props.onResetFormCustom(['infoEssentialMedicalAppliancesItems']);
      }
      if (name === 'Private Duty Nursing') {
        this.props.onResetFormCustom(['infoPrivateDutyNursingItems']);
      }
      if (name === 'Fracture Treatment') {
        this.props.onResetFormCustom(['infoFractureTreatmentItems']);
      }
      if (name === 'Maternity Benefits') {
        this.props.onResetFormCustom([
          'maternityBenefitsDateOfConception',
          'maternityBenefitsAnticipatedDueDate',
          'maternityBenefitsRoutinePreNatalCare',
          'maternityBenefitsComplicationsOfPregnancy',
          'maternityBenefitsInvoluntaryTermination',
          'infoRoutinePreNatalCareItems',
          'infoComplicationsOfPregnancyItems',
          'infoInvoluntaryTerminationItems',
        ]);
      }
      if (name === 'Professional Services') {
        this.props.onResetFormCustom([
          'professionalServicesPhysiotherapist',
          'professionalServicesChiropractor',
          'professionalServicesChiropodist',
          'professionalServicesOsteopath',
          'professionalServicesPodiatrist',
          'professionalServicesAcupuncturist',
          'professionalServicesNaturopath',
          'professionalServicesSpeechTherapist',
          'professionalServicesMentalHealthOrSupportPractitioner',
          'infoPhysiotherapistItems',
          'infoChiropractorItems',
          'infoChiropodistItems',
          'infoOsteopathItems',
          'infoPodiatristItems',
          'infoAcupuncturistItems',
          'infoNaturopathItems',
          'infoSpeechTherapistItems',
          'infoMentalHealthOrSupportPractitionerItems',
        ]);
      }
      if (name === 'Rehabilitation Treatment') {
        this.props.onResetFormCustom(['infoRehabilitationTreatmentItems']);
      }
      if (name === 'Dental Services') {
        this.props.onResetFormCustom([
          'dentalServicesDentalAccident',
          'dentalServicesImpactedWisdomTooth',
          'dentalServicesDentalPainOther',
          'infoDentalAccidentItems',
          'infoImpactedWisdomToothItems',
          'infoDentalPainOtherItems',
        ]);
      }
      if (name === 'Prescription Glasses, Contact Lenses or Hearing Aids') {
        this.props.onResetFormCustom(['infoPrescriptionGlassesContactLensesHearingAidsItems']);
      }
      if (name === 'Tutorial Services') {
        this.props.onResetFormCustom(['infoTutorialServicesItems']);
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
    this.props.setFormHasChanges(true);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  // Render checkbox for Doctor's Visit
  // eslint-disable-next-line react/sort-comp
  renderDoctorVisitCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = "Doctor's Visit";
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxDoctorVisit} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <span>
            <div className="col-sm-12 form-group">
              {this.renderDoctorVisitQuestions()}
            </div>
          </span>
        )}
      </div>
    );
  };

  // Render checkbox for Diagnostic Tests
  renderDiagnosticTestsCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Diagnostic Tests';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxDiagnosticTests} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderDiagnosticTestsExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Prescription Drugs
  renderPrescriptionDrugsCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Prescription Drugs';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxPrescriptionDrugs} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderPrescriptionDrugsExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Ambulance Services
  renderAmbulanceServicesCheckbox = (expensesSelected, isReadOnly) => {
    const checkboxValue = 'Ambulance Services';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxAmbulanceServices} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderAmbulanceServicesQuestions()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Hospitalization
  renderHospitalizationCheckbox = (expensesSelected, isReadOnly, claimCodeChecks) => {
    const checkboxValue = 'Hospitalization';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxHospitalization} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderHospitalizationQuestions(claimCodeChecks)}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Essential Medical Appliances
  renderEssentialMedicalAppliancesCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Essential Medical Appliances';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxEssentialMedicalAppliances} />
        </span>
        <FNOLTooltip
          dataFor="essential-medical-appliances-tooltip"
          content={intl.formatMessage(messages.tooltipEssentialMedicalAppliances)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderEssentialMedicalAppliancesExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Private Duty Nursing
  renderPrivateDutyNursingCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Private Duty Nursing';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxPrivateDutyNursing} />
        </span>
        <FNOLTooltip
          dataFor="private-duty-nursing-tooltip"
          content={intl.formatMessage(messages.tooltipPrivateDutyNursing)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderPrivateDutyNursingExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Fracture Treatment
  renderFractureTreatmentCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Fracture Treatment';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxFractureTreatment} />
        </span>
        <FNOLTooltip
          dataFor="fracture-treatment-tooltip"
          content={intl.formatMessage(messages.tooltipFractureTreatment)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderFractureTreatmentExpenses()}
          </div>
        )}
      </div>
    );
  };

  // Handler for Maternity Benefits sub-checkboxes
  handleMaternityBenefitsSubCheckbox = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    
    // Reset expense items when unchecking
    if (!value) {
      const fieldMap = {
        'form.maternityBenefitsRoutinePreNatalCare': 'infoRoutinePreNatalCareItems',
        'form.maternityBenefitsComplicationsOfPregnancy': 'infoComplicationsOfPregnancyItems',
        'form.maternityBenefitsInvoluntaryTermination': 'infoInvoluntaryTerminationItems',
      };
      if (fieldMap[propertyName]) {
        this.props.onResetFormCustom([fieldMap[propertyName]]);
      }
    }
  };

  // Handler for Doctor Visit sub-checkboxes
  handleDoctorVisitSubCheckbox = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    
    // Reset expense items when unchecking
    if (!value) {
      const fieldMap = {
        'form.doctorVisitSTITesting': 'infoSTITestingItems',
        'form.doctorVisitVaccinationsTBTesting': 'infoVaccinationsTBTestingItems',
        'form.doctorVisitEyeExamination': 'infoEyeExaminationItems',
      };
      if (fieldMap[propertyName]) {
        this.props.onResetFormCustom([fieldMap[propertyName]]);
      }
    }
  };

  // Handler for Hospitalization sub-checkboxes
  handleHospitalizationSubCheckbox = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    
    // Reset expense items when unchecking
    if (!value) {
      const fieldMap = {
        'form.hospitalizationHospitalInvoice': 'infoHospitalFeesItems',
        'form.hospitalizationPhysicianInvoice': 'infoInpatientPhysicianFeesItems',
        'form.hospitalizationLabDiagnostic': 'infoXrayLabsDiagnosticsItems',
        'form.hospitalizationOtherRelated': 'infoOtherHospitalizationItems',
      };
      if (fieldMap[propertyName]) {
        this.props.onResetFormCustom([fieldMap[propertyName]]);
      }
    }
  };

  // Handler for Professional Services sub-checkboxes
  handleProfessionalServicesSubCheckbox = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    
    // Reset expense items when unchecking
    if (!value) {
      const fieldMap = {
        'form.professionalServicesPhysiotherapist': 'infoPhysiotherapistItems',
        'form.professionalServicesChiropractor': 'infoChiropractorItems',
        'form.professionalServicesChiropodist': 'infoChiropodistItems',
        'form.professionalServicesOsteopath': 'infoOsteopathItems',
        'form.professionalServicesPodiatrist': 'infoPodiatristItems',
        'form.professionalServicesAcupuncturist': 'infoAcupuncturistItems',
        'form.professionalServicesNaturopath': 'infoNaturopathItems',
        'form.professionalServicesSpeechTherapist': 'infoSpeechTherapistItems',
        'form.professionalServicesMentalHealthOrSupportPractitioner': 'infoMentalHealthOrSupportPractitionerItems',
      };
      if (fieldMap[propertyName]) {
        this.props.onResetFormCustom([fieldMap[propertyName]]);
      }
    }
  };

  // Handler for Dental Services sub-checkboxes
  handleDentalServicesSubCheckbox = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
    
    // Reset expense items when unchecking
    if (!value) {
      const fieldMap = {
        'form.dentalServicesDentalAccident': 'infoDentalAccidentItems',
        'form.dentalServicesImpactedWisdomTooth': 'infoImpactedWisdomToothItems',
        'form.dentalServicesDentalPainOther': 'infoDentalPainOtherItems',
      };
      if (fieldMap[propertyName]) {
        this.props.onResetFormCustom([fieldMap[propertyName]]);
      }
    }
  };

  // Render checkbox for Professional Services
  renderProfessionalServicesCheckbox = (expensesSelected, isReadOnly, claimCodeChecks) => {
    const {intl} = this.props;
    const checkboxValue = 'Professional Services';
    const { form, isSummary, submitted } = this.props;
    const isReadOnlyField = submitted || isSummary;
    
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxProfessionalServices} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group ml-4">
            {/* Note text */}
            <div className="col-sm-12 form-group mt-2 mb-3">
              <p className="text-muted">
                <FormattedMessage {...messages.noteProfessionalServices} />
              </p>
            </div>
            
            {/* Physiotherapist */}
            {claimCodeChecks.isRenderPhysiotherapist && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesPhysiotherapist === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesPhysiotherapist')}
                />
                <span>
                  <FormattedMessage {...messages.headerPhysiotherapist} />
                </span>
                {form.professionalServicesPhysiotherapist === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoPhysiotherapistItems')}
                  </div>
                )}
              </div>
            )}

            {/* Chiropractor */}
            {claimCodeChecks.isRenderChiropractor && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesChiropractor === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesChiropractor')}
                />
                <span>
                  <FormattedMessage {...messages.headerChiropractor} />
                </span>
                {form.professionalServicesChiropractor === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoChiropractorItems')}
                  </div>
                )}
              </div>
            )}

            {/* Chiropodist */}
            {claimCodeChecks.isRenderChiropodist && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesChiropodist === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesChiropodist')}
                />
                <span>
                  <FormattedMessage {...messages.headerChiropodist} />
                </span>
                {form.professionalServicesChiropodist === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoChiropodistItems')}
                  </div>
                )}
              </div>
            )}

            {/* Osteopath */}
            {claimCodeChecks.isRenderOsteopath && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesOsteopath === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesOsteopath')}
                />
                <span>
                  <FormattedMessage {...messages.headerOsteopath} />
                </span>
                {form.professionalServicesOsteopath === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoOsteopathItems')}
                  </div>
                )}
              </div>
            )}

            {/* Podiatrist */}
            {claimCodeChecks.isRenderPodiatrist && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesPodiatrist === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesPodiatrist')}
                />
                <span>
                  <FormattedMessage {...messages.headerPodiatrist} />
                </span>
                {form.professionalServicesPodiatrist === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoPodiatristItems')}
                  </div>
                )}
              </div>
            )}

            {/* Acupuncturist */}
            {claimCodeChecks.isRenderAcupuncturist && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesAcupuncturist === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesAcupuncturist')}
                />
                <span>
                  <FormattedMessage {...messages.headerAcupuncturist} />
                </span>
                {form.professionalServicesAcupuncturist === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoAcupuncturistItems')}
                  </div>
                )}
              </div>
            )}

            {/* Naturopath */}
            {claimCodeChecks.isRenderNaturopath && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesNaturopath === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesNaturopath')}
                />
                <span>
                  <FormattedMessage {...messages.headerNaturopath} />
                </span>
                {form.professionalServicesNaturopath === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoNaturopathItems')}
                  </div>
                )}
              </div>
            )}

            {/* Speech Therapist */}
            {claimCodeChecks.isRenderSpeechTherapist && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesSpeechTherapist === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesSpeechTherapist')}
                />
                <span>
                  <FormattedMessage {...messages.headerSpeechTherapist} />
                </span>
                {form.professionalServicesSpeechTherapist === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoSpeechTherapistItems')}
                  </div>
                )}
              </div>
            )}

            {/* Mental Health or Support Practitioner */}
            {claimCodeChecks.isRenderMentalHealthOrSupportPractitioner && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.professionalServicesMentalHealthOrSupportPractitioner === true}
                  onChange={this.handleProfessionalServicesSubCheckbox('form.professionalServicesMentalHealthOrSupportPractitioner')}
                />
                <span>
                  <FormattedMessage {...messages.headerMentalHealthOrSupportPractitioner} />
                </span>
                {form.professionalServicesMentalHealthOrSupportPractitioner === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoMentalHealthOrSupportPractitionerItems')}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Rehabilitation Treatment
  renderRehabilitationTreatmentCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Rehabilitation Treatment';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxRehabilitationTreatment} />
        </span>
        <FNOLTooltip
          dataFor="rehabilitation-treatment-tooltip"
          content={intl.formatMessage(messages.noteRehabilitationTreatment)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group ml-4">
            {/* Expense box */}
            <div className="col-sm-12 form-group">
              {this.renderExpensesItems('infoRehabilitationTreatmentItems')}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Prescription Glasses, Contact Lenses or Hearing Aids
  renderPrescriptionGlassesContactLensesHearingAidsCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Prescription Glasses, Contact Lenses or Hearing Aids';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxPrescriptionGlassesContactLensesHearingAids} />
        </span>
        <FNOLTooltip
          dataFor="prescription-glasses-contact-lenses-hearing-aids-tooltip"
          content={intl.formatMessage(messages.tooltipPrescriptionGlassesContactLensesHearingAids)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderExpensesItems('infoPrescriptionGlassesContactLensesHearingAidsItems')}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Tutorial Services
  renderTutorialServicesCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Tutorial Services';
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxTutorialServices} />
        </span>
        <FNOLTooltip
          dataFor="tutorial-services-tooltip"
          content={intl.formatMessage(messages.tooltipTutorialServices)}
        />
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group">
            {this.renderExpensesItems('infoTutorialServicesItems')}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Dental Services
  renderDentalServicesCheckbox = (expensesSelected, isReadOnly, claimCodeChecks) => {
    const { form, isSummary, submitted } = this.props;
    const isReadOnlyField = submitted || isSummary;
    const checkboxValue = 'Dental Services';
    
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxDentalServices} />
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group ml-4">
            {/* Dental Accident */}
            {claimCodeChecks.isRenderDentalAccident && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.dentalServicesDentalAccident === true}
                  onChange={this.handleDentalServicesSubCheckbox('form.dentalServicesDentalAccident')}
                />
                <span>
                  <FormattedMessage {...messages.headerDentalAccident} />
                </span>
                {form.dentalServicesDentalAccident === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoDentalAccidentItems')}
                  </div>
                )}
              </div>
            )}

            {/* Impacted Wisdom Tooth */}
            {claimCodeChecks.isRenderImpactedWisdomTooth && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.dentalServicesImpactedWisdomTooth === true}
                  onChange={this.handleDentalServicesSubCheckbox('form.dentalServicesImpactedWisdomTooth')}
                />
                <span>
                  <FormattedMessage {...messages.headerImpactedWisdomTooth} />
                </span>
                {form.dentalServicesImpactedWisdomTooth === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoImpactedWisdomToothItems')}
                  </div>
                )}
              </div>
            )}

            {/* Dental pain other than accident or wisdom tooth */}
            {claimCodeChecks.isRenderDentalPainOther && (
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.dentalServicesDentalPainOther === true}
                  onChange={this.handleDentalServicesSubCheckbox('form.dentalServicesDentalPainOther')}
                />
                <span>
                  <FormattedMessage {...messages.headerDentalPainOther} />
                </span>
                {form.dentalServicesDentalPainOther === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoDentalPainOtherItems')}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render checkbox for Maternity Benefits
  renderMaternityBenefitsCheckbox = (expensesSelected, isReadOnly) => {
    const {intl} = this.props;
    const checkboxValue = 'Maternity Benefits';
    const { form, isSummary, submitted } = this.props;
    const isReadOnlyField = submitted || isSummary;
    
    return (
      <div className="col-sm-12 form-group">
        <input
          disabled={isReadOnly}
          type="checkbox"
          name={checkboxValue}
          checked={expensesSelected.includes(checkboxValue)}
          onChange={this.handleExpensesSelected('form.whatExpensesAreYouClaimingFor')}
        />
        <span>
          <FormattedMessage {...messages.checkboxMaternityBenefits} /> 
        </span>
        {expensesSelected.includes(checkboxValue) && (
          <div className="col-sm-12 form-group ml-4 mt-2">
            <div className="row">
              {/* Date of Conception */}
              <div className="form-group col-sm-6">
                <div className="d-flex align-items-center">
                  <label className="mb-0 mr-2">
                    <FormattedMessage {...messages.dateOfConception} />
                  </label>
                  <FNOLTooltip
                    dataFor="date-of-conception-tooltip"
                    content={intl.formatMessage(messages.dateOfConceptionTooltip)}
                  />
                </div>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnlyField}
                  name="maternityBenefitsDateOfConception"
                  type="text"
                  onDayChange={this.handleDayChange('form.maternityBenefitsDateOfConception')}
                  value={form.maternityBenefitsDateOfConception}
                  placeholder=""
                  allowFutureDates={true}
                />
              </div>
              {/* Anticipated Due Date */}
              <div className="form-group col-sm-6">
                <label className="mb-0">
                  <FormattedMessage {...messages.anticipatedDueDate} />
                </label>
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnlyField}
                  name="maternityBenefitsAnticipatedDueDate"
                  type="text"
                  onDayChange={this.handleDayChange('form.maternityBenefitsAnticipatedDueDate')}
                  value={form.maternityBenefitsAnticipatedDueDate}
                  placeholder=""
                  allowFutureDates={true}
                />
              </div>
            </div>
            
            {/* Routine Pre-Natal Care Checkbox */}
            <div className="col-sm-12 form-group mt-3">
              <input
                disabled={isReadOnly}
                type="checkbox"
                checked={form.maternityBenefitsRoutinePreNatalCare === true}
                onChange={this.handleMaternityBenefitsSubCheckbox('form.maternityBenefitsRoutinePreNatalCare')}
              />
              <span>
                <FormattedMessage {...messages.headerRoutinePreNatalCare} />
              </span>
              {form.maternityBenefitsRoutinePreNatalCare === true && (
                <div className="ml-4 mt-2">
                  {this.renderExpensesItems('infoRoutinePreNatalCareItems')}
                </div>
              )}
            </div>
            
            {/* Complications of Pregnancy Checkbox */}
            <div className="col-sm-12 form-group mt-3">
              <input
                disabled={isReadOnly}
                type="checkbox"
                checked={form.maternityBenefitsComplicationsOfPregnancy === true}
                onChange={this.handleMaternityBenefitsSubCheckbox('form.maternityBenefitsComplicationsOfPregnancy')}
              />
              <span>
                <FormattedMessage {...messages.headerComplicationsOfPregnancy} />
              </span>
              {form.maternityBenefitsComplicationsOfPregnancy === true && (
                <div className="ml-4 mt-2">
                  {this.renderExpensesItems('infoComplicationsOfPregnancyItems')}
                </div>
              )}
            </div>
            
            {/* Involuntary termination Checkbox */}
            <div className="col-sm-12 form-group mt-3">
              <input
                disabled={isReadOnly}
                type="checkbox"
                checked={form.maternityBenefitsInvoluntaryTermination === true}
                onChange={this.handleMaternityBenefitsSubCheckbox('form.maternityBenefitsInvoluntaryTermination')}
              />
              <span>
                <FormattedMessage {...messages.headerInvoluntaryTermination} />
              </span>
              {form.maternityBenefitsInvoluntaryTermination === true && (
                <div className="ml-4 mt-2">
                  {this.renderExpensesItems('infoInvoluntaryTerminationItems')}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Render Doctor's Visit questions and expense forms
  renderDoctorVisitQuestions = () => {
    const { form, isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-2">
        {/* Question: Did you have your visit by telephone or video call? (Telemedicine Benefit) */}
        <div className="col-sm-12 form-group">
          <div className="mt-2">
            <PageSectionHeader>
              <FormattedMessage {...messages.questionDidYouHaveYourVisitByTelephoneOrVideoCall} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={form.doctorVisitTelemedicine === 'true'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitTelemedicine')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={form.doctorVisitTelemedicine === 'false'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitTelemedicine')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {form.doctorVisitTelemedicine === 'true' && (
            <div className="mt-2">
              <b className="pt-2"><FormattedMessage {...messages.headerTelemedicineBenefit} /></b>
              {this.renderExpensesItems('infoTelemedicineItems')}
            </div>
          )}
        </div>

        {/* Question: Is the doctor's visit for an Annual Physical Visit? */}
        <div className="col-sm-12 form-group">
          <div className="mt-2">
            <PageSectionHeader>
              <FormattedMessage {...messages.questionIsTheDoctorsVisitForAnAnnualPhysicalExam} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={form.doctorVisitAnnualPhysicalExam === 'true'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitAnnualPhysicalExam')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={form.doctorVisitAnnualPhysicalExam === 'false'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitAnnualPhysicalExam')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {form.doctorVisitAnnualPhysicalExam === 'true' && (
            <div className="mt-2">
              <b className="pt-2"><FormattedMessage {...messages.headerAnnualPhysicalExam} /></b>
              {this.renderExpensesItems('infoAnnualPhysicalExamItems')}
            </div>
          )}
        </div>

        {/* Question: First visit - Only show if Annual Physical Visit is "No" */}
        {form.doctorVisitAnnualPhysicalExam === 'false' && (
          <div className="col-sm-12 form-group ml-2">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionFirstVisitIllnessAccident} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.doctorVisitFirstVisit === 'true'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFirstVisit')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.doctorVisitFirstVisit === 'false'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFirstVisit')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.doctorVisitFirstVisit === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerOutpatientPhysicianFees} /></b>
                {this.renderExpensesItems('infoOutpatientPhysicianFeesItems')}
              </div>
            )}
          </div>
        )}

        {/* Question: Follow up visit - Only show if Annual Physical Visit is "No" and First Visit is "No" */}
        {form.doctorVisitAnnualPhysicalExam === 'false' && form.doctorVisitFirstVisit === 'false' && (
          <div className="col-sm-12 form-group ml-4">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionFollowUpVisit} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.doctorVisitFollowUp === 'true'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFollowUp')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.doctorVisitFollowUp === 'false'}
                    onChange={this.handleRadioButtonChange('form.doctorVisitFollowUp')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.doctorVisitFollowUp === 'true' && (
              <div className="mt-2">
                <div className="d-flex align-items-center pt-2">
                  <b className="mr-2"><FormattedMessage {...messages.headerFollowUpVisit} /></b>
                  <FNOLTooltip
                    dataFor="follow-up-visit-tooltip"
                    content={intl.formatMessage(messages.tooltipFollowUpVisit)}
                  />
                </div>
                {this.renderExpensesItems('infoFollowUpVisitItems')}
              </div>
            )}

            {/* Question: Follow up visit for fracture - shown when previous answer is No */}
            {form.doctorVisitFollowUp === 'false' && (
              <div className="col-sm-12 form-group ml-2">
                <div className="mt-2">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.questionFollowUpVisitFracture} />
                  </PageSectionHeader>
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="true"
                        checked={form.doctorVisitFollowUpFracture === 'true'}
                        onChange={this.handleRadioButtonChange('form.doctorVisitFollowUpFracture')}
                      />
                      <FormattedMessage {...messages.yes} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="false"
                        checked={form.doctorVisitFollowUpFracture === 'false'}
                        onChange={this.handleRadioButtonChange('form.doctorVisitFollowUpFracture')}
                      />
                      <FormattedMessage {...messages.no} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
                {form.doctorVisitFollowUpFracture === 'true' && (
                  <div className="mt-2">
                    <div className="d-flex align-items-center pt-2">
                      <b className="mr-2"><FormattedMessage {...messages.headerFractureTreatment} /></b>
                      <FNOLTooltip 
                        dataFor="fracture-treatment-header-tooltip"
                        content={intl.formatMessage(messages.tooltipFractureTreatmentHeader)}
                      />
                    </div>
                    {this.renderExpensesItems('infoFollowUpFractureItems')}
                  </div>
                )}
                {form.doctorVisitFollowUpFracture === 'false' && (
                  <div className="mt-2 alert alert-danger">
                    <FormattedMessage {...messages.messageNoOngoingCare} />
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Question: 2nd question - STI testing, vaccinations, TB testing, or eye exam */}
        <div className="col-sm-12 form-group">
          <div className="mt-2">
            <PageSectionHeader>
              <FormattedMessage {...messages.questionIsTheDoctorsVisitForSTITestingVaccinationsTBEyeExam} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={form.doctorVisitSTIVaccinationsTBEyeExam === 'true'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitSTIVaccinationsTBEyeExam')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={form.doctorVisitSTIVaccinationsTBEyeExam === 'false'}
                  onChange={this.handleRadioButtonChange('form.doctorVisitSTIVaccinationsTBEyeExam')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {form.doctorVisitSTIVaccinationsTBEyeExam === 'true' && (
            <div className="mt-2 ml-2">
              {/* Sexually Transmitted Infection Testing */}
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.doctorVisitSTITesting === true}
                  onChange={this.handleDoctorVisitSubCheckbox('form.doctorVisitSTITesting')}
                />
                <span>
                  <FormattedMessage {...messages.headerSTITesting} />
                </span>
                {form.doctorVisitSTITesting === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoSTITestingItems')}
                  </div>
                )}
              </div>

              {/* Vaccinations and Tuberculosis Testing */}
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.doctorVisitVaccinationsTBTesting === true}
                  onChange={this.handleDoctorVisitSubCheckbox('form.doctorVisitVaccinationsTBTesting')}
                />
                <span>
                  <FormattedMessage {...messages.headerVaccinationsTBTesting} />
                </span>
                {form.doctorVisitVaccinationsTBTesting === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoVaccinationsTBTestingItems')}
                  </div>
                )}
              </div>

              {/* Eye Examination */}
              <div className="col-sm-12 form-group mt-3">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  checked={form.doctorVisitEyeExamination === true}
                  onChange={this.handleDoctorVisitSubCheckbox('form.doctorVisitEyeExamination')}
                />
                <span>
                  <FormattedMessage {...messages.headerEyeExamination} />
                </span>
                <FNOLTooltip
                  dataFor="eye-examination-tooltip"
                  content={intl.formatMessage(messages.tooltipEyeExamination)}
                />
                {form.doctorVisitEyeExamination === true && (
                  <div className="ml-4 mt-2">
                    {this.renderExpensesItems('infoEyeExaminationItems')}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Render Diagnostic Tests expense form
  renderDiagnosticTestsExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoDiagnosticTestsItems')}
    </div>
  );

  // Render Prescription Drugs expense form
  renderPrescriptionDrugsExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoPrescriptionDrugsItems')}
    </div>
  );

  // Render Essential Medical Appliances expenses
  renderEssentialMedicalAppliancesExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoEssentialMedicalAppliancesItems')}
    </div>
  );

  // Render Private Duty Nursing expenses
  renderPrivateDutyNursingExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoPrivateDutyNursingItems')}
    </div>
  );

  // Render Fracture Treatment expenses
  renderFractureTreatmentExpenses = () => (
    <div className="ml-4">
      {this.renderExpensesItems('infoFractureTreatmentItems')}
    </div>
  );

  // Render Ambulance Services questions
  renderAmbulanceServicesQuestions = () => {
    const { form, isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-4">
        {/* Ground Ambulance Question */}
        <div className="mt-2">
          <PageSectionHeader>
            <FormattedMessage {...messages.questionGroundAmbulance} />
          </PageSectionHeader>
          <FlexBox>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="true"
                checked={form.ambulanceGroundService === 'true'}
                onChange={this.handleRadioButtonChange('form.ambulanceGroundService')}
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="false"
                checked={form.ambulanceGroundService === 'false'}
                onChange={this.handleRadioButtonChange('form.ambulanceGroundService')}
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </div>
        {form.ambulanceGroundService === 'true' && (
          <div className="mt-2">
            <b className="pt-2"><FormattedMessage {...messages.headerGroundAmbulance} /></b>
            {this.renderExpensesItems('infoGroundAmbulanceItems')}
          </div>
        )}

        {/* Air Ambulance Question - Only show if Ground Ambulance is "No" */}
        {form.ambulanceGroundService === 'false' && (
          <div className="ml-4">
            <div className="mt-2">
              <PageSectionHeader>
                <FormattedMessage {...messages.questionAirAmbulance} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={form.ambulanceAirService === 'true'}
                    onChange={this.handleRadioButtonChange('form.ambulanceAirService')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={form.ambulanceAirService === 'false'}
                    onChange={this.handleRadioButtonChange('form.ambulanceAirService')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {form.ambulanceAirService === 'true' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerAirAmbulance} /></b>
                {this.renderExpensesItems('infoAirAmbulanceItems')}
              </div>
            )}
            {form.ambulanceAirService === 'false' && (
              <div className="mt-2">
                <b className="pt-2"><FormattedMessage {...messages.otherTypesOfAmbulance} /></b>
                {this.renderExpensesItems('infoGroundAmbulanceItems')}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Render Hospitalization questions
  renderHospitalizationQuestions = (claimCodeChecks) => {
    const { form, isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="ml-2">
        {/* Mental health or psychiatric hospitalization */}
        {claimCodeChecks.isRenderMentalHealthPsychiatric && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationMentalHealthPsychiatric === true}
              onChange={this.handleChange('form.hospitalizationMentalHealthPsychiatric')}
            />
            <span>
              <FormattedMessage {...messages.headerMentalHealthPsychiatric} />
            </span>
            {form.hospitalizationMentalHealthPsychiatric === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerMentalHealthPsychiatric} /></b>
                {this.renderExpensesItems('infoMentalHealthPsychiatricItems')}
              </div>
            )}
          </div>
        )}

        {/* Hospital Invoice Checkbox */}
        {claimCodeChecks.isRenderHospitalFees && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationHospitalInvoice === true}
              onChange={this.handleHospitalizationSubCheckbox('form.hospitalizationHospitalInvoice')}
            />
            <span>
              <FormattedMessage {...messages.headerHospitalFees} />
            </span>
            {form.hospitalizationHospitalInvoice === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerHospitalFees} /></b>
                {this.renderExpensesItems('infoHospitalFeesItems')}
              </div>
            )}
          </div>
        )}

        {/* Physician Invoice Checkbox */}
        {claimCodeChecks.isRenderInpatientPhysicianFees && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationPhysicianInvoice === true}
              onChange={this.handleHospitalizationSubCheckbox('form.hospitalizationPhysicianInvoice')}
            />
            <span>
              <FormattedMessage {...messages.headerInpatientPhysicianFees} />
            </span>
            {form.hospitalizationPhysicianInvoice === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.expenseHeaderPhysicianFees} /></b>
                {this.renderExpensesItems('infoInpatientPhysicianFeesItems')}
              </div>
            )}
          </div>
        )}

        {/* Lab/Diagnostic Facility Checkbox */}
        {claimCodeChecks.isRenderXrayLabsDiagnostics && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationLabDiagnostic === true}
              onChange={this.handleHospitalizationSubCheckbox('form.hospitalizationLabDiagnostic')}
            />
            <span>
              <FormattedMessage {...messages.headerXrayLabsOtherDiagnostics} />
            </span>
            {form.hospitalizationLabDiagnostic === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerXrayLabsOtherDiagnostics} /></b>
                {this.renderExpensesItems('infoXrayLabsDiagnosticsItems')}
              </div>
            )}
          </div>
        )}

        {/* Emergency Air Transportation */}
        {claimCodeChecks.isRenderEmergencyAirTransportation && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationEmergencyAirTransportation === true}
              onChange={this.handleChange('form.hospitalizationEmergencyAirTransportation')}
            />
            <span>
              <FormattedMessage {...messages.headerEmergencyAirTransportation} />
            </span>
            {form.hospitalizationEmergencyAirTransportation === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerEmergencyAirTransportation} /></b>
                {this.renderExpensesItems('infoEmergencyAirTransportationItems')}
              </div>
            )}
          </div>
        )}

        {/* Airfare to Return Home For Treatment Benefit */}
        {claimCodeChecks.isRenderAirfareReturnHome && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationAirfareReturnHome === true}
              onChange={this.handleChange('form.hospitalizationAirfareReturnHome')}
            />
            <span>
              <FormattedMessage {...messages.headerAirfareReturnHome} />
            </span>
            {form.hospitalizationAirfareReturnHome === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerAirfareReturnHome} /></b>
                {this.renderExpensesItems('infoAirfareReturnHomeItems')}
              </div>
            )}
          </div>
        )}

        {/* Family Transportation */}
        {claimCodeChecks.isRenderFamilyTransportation && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationFamilyTransportation === true}
              onChange={this.handleChange('form.hospitalizationFamilyTransportation')}
            />
            <span className="align-items-center">
              <FormattedMessage {...messages.headerFamilyTransportation} />
              <FNOLTooltip
                dataFor="familyTransportationTooltip"
                content={intl.formatMessage(messages.tooltipFamilyTransportation)}
              />
            </span>
            {form.hospitalizationFamilyTransportation === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerFamilyTransportation} /></b>
                {this.renderExpensesItems('infoFamilyTransportationItems')}
              </div>
            )}
          </div>
        )}

        {/* Medical Attendant */}
        {claimCodeChecks.isRenderMedicalAttendant && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationMedicalAttendant === true}
              onChange={this.handleChange('form.hospitalizationMedicalAttendant')}
            />
            <span>
              <FormattedMessage {...messages.headerMedicalAttendant} />
            </span>
            {form.hospitalizationMedicalAttendant === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerMedicalAttendant} /></b>
                {this.renderExpensesItems('infoMedicalAttendantItems')}
              </div>
            )}
          </div>
        )}

        {/* Other Hospitalization Related Checkbox */}
        {claimCodeChecks.isRenderOtherHospitalization && (
          <div className="col-sm-12 form-group mt-3">
            <input
              disabled={isReadOnly}
              type="checkbox"
              checked={form.hospitalizationOtherRelated === true}
              onChange={this.handleHospitalizationSubCheckbox('form.hospitalizationOtherRelated')}
            />
            <span>
              <FormattedMessage {...messages.headerOtherHospitalizationRelated} />
            </span>
            {form.hospitalizationOtherRelated === true && (
              <div className="ml-4 mt-2">
                <b className="pt-2"><FormattedMessage {...messages.headerOtherHospitalizationRelated} /></b>
                {this.renderExpensesItems('infoOtherHospitalizationItems')}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Master render function for all medical expense checkboxes
  renderAllMedicalExpenseCheckboxes = (expensesSelected, isReadOnly, claimCodeChecks) => {
    const checkboxes = [
      {
        render: this.renderDoctorVisitCheckbox,
        key: 'doctorVisit',
        shouldRender: claimCodeChecks.isRenderDoctorVisit,
      },
      {
        render: this.renderDiagnosticTestsCheckbox,
        key: 'diagnosticTests',
        shouldRender: claimCodeChecks.isRenderDiagnosticTests,
      },
      {
        render: this.renderPrescriptionDrugsCheckbox,
        key: 'prescriptionDrugs',
        shouldRender: claimCodeChecks.isRenderPrescriptionDrugs,
      },
      {
        render: this.renderAmbulanceServicesCheckbox,
        key: 'ambulanceServices',
        shouldRender: claimCodeChecks.isRenderAmbulanceServices,
      },
      {
        render: this.renderHospitalizationCheckbox,
        key: 'hospitalization',
        shouldRender: claimCodeChecks.isRenderHospitalization,
      },
      {
        render: this.renderEssentialMedicalAppliancesCheckbox,
        key: 'essentialMedicalAppliances',
        shouldRender: claimCodeChecks.isRenderEssentialMedicalAppliances,
      },
      {
        render: this.renderPrivateDutyNursingCheckbox,
        key: 'privateDutyNursing',
        shouldRender: claimCodeChecks.isRenderPrivateDutyNursing,
      },
      {
        render: this.renderFractureTreatmentCheckbox,
        key: 'fractureTreatment',
        shouldRender: claimCodeChecks.isRenderFractureTreatment,
      },
      {
        render: this.renderMaternityBenefitsCheckbox,
        key: 'maternityBenefits',
        shouldRender: claimCodeChecks.isRenderMaternityBenefits,
      },
      {
        render: this.renderProfessionalServicesCheckbox,
        key: 'professionalServices',
        shouldRender: claimCodeChecks.isRenderProfessionalServices,
      },
      {
        render: this.renderRehabilitationTreatmentCheckbox,
        key: 'rehabilitationTreatment',
        shouldRender: claimCodeChecks.isRenderRehabilitationTreatment,
      },
      {
        render: this.renderDentalServicesCheckbox,
        key: 'dentalServices',
        shouldRender: claimCodeChecks.isRenderDentalServices,
      },
      {
        render: this.renderPrescriptionGlassesContactLensesHearingAidsCheckbox,
        key: 'prescriptionGlassesContactLensesHearingAids',
        shouldRender: claimCodeChecks.isRenderPrescriptionGlassesContactLensesHearingAids,
      },
      {
        render: this.renderTutorialServicesCheckbox,
        key: 'tutorialServices',
        shouldRender: claimCodeChecks.isRenderTutorialServices,
      },
    ];

    return (
      <div className="pt-2 col-sm-12">
        {checkboxes
          .filter(({ shouldRender }) => shouldRender)
          .map(({ render, key }) => (
            <div key={key} className="mb-3">
              {key === 'hospitalization' || key === 'professionalServices' || key === 'dentalServices'
                ? render(expensesSelected, isReadOnly, claimCodeChecks)
                : render(expensesSelected, isReadOnly)}
            </div>
          ))}
      </div>
    );
  };

  // Generic handler for all expense type changes
  handleExpenseTypeChange = (formField) => (data) => {
    this.props.onFormDataChange(`form.${formField}`, fromJS(data));
    this.props.setFormHasChanges(true);
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      doctorVisitFollowUpFracture,
      doctorVisitSTITesting,
      doctorVisitVaccinationsTBTesting,
      doctorVisitEyeExamination,
    } = this.props.form;

    // Check if all first question options are answered with 'false' (no benefits from first question)
    const allFirstQuestionNo = doctorVisitFollowUpFracture === 'false';

    // Check if any second question benefits are selected
    const hasSecondQuestionBenefits = 
      doctorVisitSTITesting === true ||
      doctorVisitVaccinationsTBTesting === true ||
      doctorVisitEyeExamination === true;

    // If all first question options are "No" but second question has benefits, allow submission
    // Otherwise, if all first question options are "No" and no second question benefits, reject
    const isOngoingCareRejected = allFirstQuestionNo && !hasSecondQuestionBenefits;

    const valid = this.validatorGroup.checkValidation() && !isOngoingCareRejected;
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  // Generic handler for radio button changes that clears related fields
  // Usage: onChange={this.handleRadioButtonChange('form.fieldName')}
  // This handler automatically clears related form fields based on radioFormResets configuration
  handleRadioButtonChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.value;

    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);

    // Get the field name from propertyName (e.g., 'form.ambulanceGroundService' -> 'ambulanceGroundService')
    const fieldName = propertyName.replace('form.', '');

    // Check if we have reset mappings for this field
    if (this.radioFormResets[fieldName] && this.radioFormResets[fieldName][value]) {
      this.props.onResetFormCustom(this.radioFormResets[fieldName][value]);
    }
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
      this.props.setFormHasChanges(true);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.handleFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    this.props.setFormHasChanges(true);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  // Generic render method for all expense type items
  renderExpensesItems(formField, hideAddButton = false) {
    const items = this.props.form[formField];
    if (!items) {
      return null;
    }

    const newMedicalExpenseItems = this.appendIds(items);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, intl } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.handleExpenseTypeChange(formField)}
          isDelayed={false}
          disabled={isReadOnly}
          hideAddButton={hideAddButton}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
          intl={intl}
        />
      </div>
    );
  }

  render() {
    const {
      whatExpensesAreYouClaimingFor,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];

    // Check if medical benefits have claim codes
    const claimCodeChecks = {
      isRenderDoctorVisit: !!(stepStudentMedicalBenefitsTugoLookup.annualPhysicalExam && stepStudentMedicalBenefitsTugoLookup.annualPhysicalExam.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.outpatientPhysicianFees && stepStudentMedicalBenefitsTugoLookup.outpatientPhysicianFees.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.followUpVisit && stepStudentMedicalBenefitsTugoLookup.followUpVisit.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.stiTesting && stepStudentMedicalBenefitsTugoLookup.stiTesting.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.vaccinationsTBTesting && stepStudentMedicalBenefitsTugoLookup.vaccinationsTBTesting.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.eyeExamination && stepStudentMedicalBenefitsTugoLookup.eyeExamination.claimCode),
      isRenderDiagnosticTests: !!(stepStudentMedicalBenefitsTugoLookup.diagnosticTests && stepStudentMedicalBenefitsTugoLookup.diagnosticTests.claimCode),
      isRenderPrescriptionDrugs: !!(stepStudentMedicalBenefitsTugoLookup.prescriptionDrugs && stepStudentMedicalBenefitsTugoLookup.prescriptionDrugs.claimCode),
      isRenderAmbulanceServices: !!(stepStudentMedicalBenefitsTugoLookup.groundAmbulance && stepStudentMedicalBenefitsTugoLookup.groundAmbulance.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.airAmbulance && stepStudentMedicalBenefitsTugoLookup.airAmbulance.claimCode),
      // Hospitalization - check overall if any benefit has claim code
      isRenderHospitalization: !!(stepStudentMedicalBenefitsTugoLookup.hospitalFees && stepStudentMedicalBenefitsTugoLookup.hospitalFees.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.inpatientPhysicianFees && stepStudentMedicalBenefitsTugoLookup.inpatientPhysicianFees.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.xrayLabsDiagnostics && stepStudentMedicalBenefitsTugoLookup.xrayLabsDiagnostics.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.otherHospitalization && stepStudentMedicalBenefitsTugoLookup.otherHospitalization.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.mentalHealthPsychiatric && stepStudentMedicalBenefitsTugoLookup.mentalHealthPsychiatric.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.emergencyAirTransportation && stepStudentMedicalBenefitsTugoLookup.emergencyAirTransportation.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.airfareReturnHome && stepStudentMedicalBenefitsTugoLookup.airfareReturnHome.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.familyTransportation && stepStudentMedicalBenefitsTugoLookup.familyTransportation.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.medicalAttendant && stepStudentMedicalBenefitsTugoLookup.medicalAttendant.claimCode),
      // Individual hospitalization benefits
      isRenderMentalHealthPsychiatric: !!(stepStudentMedicalBenefitsTugoLookup.mentalHealthPsychiatric && stepStudentMedicalBenefitsTugoLookup.mentalHealthPsychiatric.claimCode),
      isRenderHospitalFees: !!(stepStudentMedicalBenefitsTugoLookup.hospitalFees && stepStudentMedicalBenefitsTugoLookup.hospitalFees.claimCode),
      isRenderInpatientPhysicianFees: !!(stepStudentMedicalBenefitsTugoLookup.inpatientPhysicianFees && stepStudentMedicalBenefitsTugoLookup.inpatientPhysicianFees.claimCode),
      isRenderXrayLabsDiagnostics: !!(stepStudentMedicalBenefitsTugoLookup.xrayLabsDiagnostics && stepStudentMedicalBenefitsTugoLookup.xrayLabsDiagnostics.claimCode),
      isRenderEmergencyAirTransportation: !!(stepStudentMedicalBenefitsTugoLookup.emergencyAirTransportation && stepStudentMedicalBenefitsTugoLookup.emergencyAirTransportation.claimCode),
      isRenderAirfareReturnHome: !!(stepStudentMedicalBenefitsTugoLookup.airfareReturnHome && stepStudentMedicalBenefitsTugoLookup.airfareReturnHome.claimCode),
      isRenderFamilyTransportation: !!(stepStudentMedicalBenefitsTugoLookup.familyTransportation && stepStudentMedicalBenefitsTugoLookup.familyTransportation.claimCode),
      isRenderMedicalAttendant: !!(stepStudentMedicalBenefitsTugoLookup.medicalAttendant && stepStudentMedicalBenefitsTugoLookup.medicalAttendant.claimCode),
      isRenderOtherHospitalization: !!(stepStudentMedicalBenefitsTugoLookup.otherHospitalization && stepStudentMedicalBenefitsTugoLookup.otherHospitalization.claimCode),
      isRenderEssentialMedicalAppliances: !!(stepStudentMedicalBenefitsTugoLookup.essentialMedicalAppliances && stepStudentMedicalBenefitsTugoLookup.essentialMedicalAppliances.claimCode),
      isRenderPrivateDutyNursing: !!(stepStudentMedicalBenefitsTugoLookup.privateDutyNursing && stepStudentMedicalBenefitsTugoLookup.privateDutyNursing.claimCode),
      isRenderFractureTreatment: !!(stepStudentMedicalBenefitsTugoLookup.fractureTreatment && stepStudentMedicalBenefitsTugoLookup.fractureTreatment.claimCode),
      isRenderMaternityBenefits: !!(stepStudentMedicalBenefitsTugoLookup.routinePreNatalCare && stepStudentMedicalBenefitsTugoLookup.routinePreNatalCare.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.complicationsOfPregnancy && stepStudentMedicalBenefitsTugoLookup.complicationsOfPregnancy.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.involuntaryTermination && stepStudentMedicalBenefitsTugoLookup.involuntaryTermination.claimCode),
      // Professional Services
      isRenderProfessionalServices: !!(stepStudentMedicalBenefitsTugoLookup.physiotherapist && stepStudentMedicalBenefitsTugoLookup.physiotherapist.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.chiropractor && stepStudentMedicalBenefitsTugoLookup.chiropractor.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.chiropodist && stepStudentMedicalBenefitsTugoLookup.chiropodist.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.osteopath && stepStudentMedicalBenefitsTugoLookup.osteopath.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.podiatrist && stepStudentMedicalBenefitsTugoLookup.podiatrist.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.acupuncturist && stepStudentMedicalBenefitsTugoLookup.acupuncturist.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.naturopath && stepStudentMedicalBenefitsTugoLookup.naturopath.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.speechTherapist && stepStudentMedicalBenefitsTugoLookup.speechTherapist.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.mentalHealthOrSupportPractitioner && stepStudentMedicalBenefitsTugoLookup.mentalHealthOrSupportPractitioner.claimCode),
      isRenderPhysiotherapist: !!(stepStudentMedicalBenefitsTugoLookup.physiotherapist && stepStudentMedicalBenefitsTugoLookup.physiotherapist.claimCode),
      isRenderChiropractor: !!(stepStudentMedicalBenefitsTugoLookup.chiropractor && stepStudentMedicalBenefitsTugoLookup.chiropractor.claimCode),
      isRenderChiropodist: !!(stepStudentMedicalBenefitsTugoLookup.chiropodist && stepStudentMedicalBenefitsTugoLookup.chiropodist.claimCode),
      isRenderOsteopath: !!(stepStudentMedicalBenefitsTugoLookup.osteopath && stepStudentMedicalBenefitsTugoLookup.osteopath.claimCode),
      isRenderPodiatrist: !!(stepStudentMedicalBenefitsTugoLookup.podiatrist && stepStudentMedicalBenefitsTugoLookup.podiatrist.claimCode),
      isRenderAcupuncturist: !!(stepStudentMedicalBenefitsTugoLookup.acupuncturist && stepStudentMedicalBenefitsTugoLookup.acupuncturist.claimCode),
      isRenderNaturopath: !!(stepStudentMedicalBenefitsTugoLookup.naturopath && stepStudentMedicalBenefitsTugoLookup.naturopath.claimCode),
      isRenderSpeechTherapist: !!(stepStudentMedicalBenefitsTugoLookup.speechTherapist && stepStudentMedicalBenefitsTugoLookup.speechTherapist.claimCode),
      isRenderMentalHealthOrSupportPractitioner: !!(stepStudentMedicalBenefitsTugoLookup.mentalHealthOrSupportPractitioner && stepStudentMedicalBenefitsTugoLookup.mentalHealthOrSupportPractitioner.claimCode),
      isRenderRehabilitationTreatment: !!(stepStudentMedicalBenefitsTugoLookup.rehabilitationTreatment && stepStudentMedicalBenefitsTugoLookup.rehabilitationTreatment.claimCode),
      // Dental Services
      isRenderDentalServices: !!(stepStudentMedicalBenefitsTugoLookup.dentalAccident && stepStudentMedicalBenefitsTugoLookup.dentalAccident.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.impactedWisdomTooth && stepStudentMedicalBenefitsTugoLookup.impactedWisdomTooth.claimCode) || !!(stepStudentMedicalBenefitsTugoLookup.dentalPainOther && stepStudentMedicalBenefitsTugoLookup.dentalPainOther.claimCode),
      isRenderDentalAccident: !!(stepStudentMedicalBenefitsTugoLookup.dentalAccident && stepStudentMedicalBenefitsTugoLookup.dentalAccident.claimCode),
      isRenderImpactedWisdomTooth: !!(stepStudentMedicalBenefitsTugoLookup.impactedWisdomTooth && stepStudentMedicalBenefitsTugoLookup.impactedWisdomTooth.claimCode),
      isRenderDentalPainOther: !!(stepStudentMedicalBenefitsTugoLookup.dentalPainOther && stepStudentMedicalBenefitsTugoLookup.dentalPainOther.claimCode),
      isRenderPrescriptionGlassesContactLensesHearingAids: !!(stepStudentMedicalBenefitsTugoLookup.prescriptionGlassesContactLensesHearingAids && stepStudentMedicalBenefitsTugoLookup.prescriptionGlassesContactLensesHearingAids.claimCode),
      isRenderTutorialServices: !!(stepStudentMedicalBenefitsTugoLookup.tutorialServices && stepStudentMedicalBenefitsTugoLookup.tutorialServices.claimCode),
    };
    return (
      <div className="app-content">
        <div>
          <div className="col-sm-12 form-group">
            <PageSectionHeader>
              <FormattedMessage {...messages.thisSectionRelatedToMedicalExpenses} />
            </PageSectionHeader>
          </div>
          <div className="col-sm-12 form-group">
            <Validate
              name="whatExpensesAreYouClaimingFor"
              validators={[required]}
              group={this.validatorGroup}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              defaultValue={expensesSelected}
              fieldName={messages.whatExpensesAreYouClaimingFor}
            >
              {/* Render all medical expense checkboxes using master render function */}
              {this.renderAllMedicalExpenseCheckboxes(expensesSelected, isReadOnly, claimCodeChecks)}
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whatExpensesAreYouClaimingFor}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        {!isSummary && (
          <WizardNavigationButtons
            onBack={this.props.prev}
            onNext={this.handleNext}
            onSave={this.handleSaveButtonClick}
            canMoveNext
            listLength={1}
            submitted={submitted}
            loading={loading}
            saveButtonId={this.saveButtonId}
            showSpinnerForElement={this.showSpinnerForElement}
            handleKeyDown={this.handleKeyDown}
            intl={intl}
            hasFormChanges={this.props.hasFormChanges}
            nextButtonRef={(ref) => {
              this.nextButton = ref;
            }}
          />
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StudentMedicalBenefitsTugo.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormCustom: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStudentMedicalBenefitsTugo(),
  errors: makeSelectStudentMedicalBenefitsTugoErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormCustom: (fields) => dispatch(resetFormFields(fields)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'studentMedicalBenefitsTugo', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(StudentMedicalBenefitsTugo);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StudentMedicalBenefits/index.js